<template>
  <Layout style="height:100%;">
    <Content style="height:100%; padding-bottom:120px;">
      <div class="container wc-container" style="margin-bottom:40px;">
        <div style="display:inline-block; width:100%;">
          <div style="float:left;">
            <Card style="width:200px; text-align:center;font-weight:bold;">
              <span style="color:#ed4014" v-if="webcast.status =='live'">LIVE {{duration}}</span>
              <span v-if="webcast.status !='live'">OFFLINE</span>
            </Card>
          </div>
          <div style="float:right">
            <Button
              type="success"
              @click="startStream"
              v-if="webcast.status =='upcoming' || streamStatus =='ended'"
            >Start Stream</Button>
            <Button type="error" @click="stopStream" v-if="webcast.status =='live'">Stop Stream</Button>
            <Button type="primary" @click="endStream">End Stream</Button>
          </div>
        </div>
        <div class="ivu-card ivu-card-bordered" style="margin-top:32px; margin-bottom: 32px;">
          <div class="ivu-card-head">
            <p>Preview</p>
            <Select v-model="selectedStream" style="width:200px" @on-change="changeCurrentStream()">
              <Option v-for="item in streams" :value="item._id" :key="item._id">{{ item.name }}</Option>
            </Select>
          </div>
          <div class="ivu-card-body">
            <PreviewPlayer />
          </div>
        </div>
      </div>
      <!--
      <iframe :src="'//'+$store.state.appsettings.copy.eventUrl+'/'+this.$store.state.webcast.copy.shortLink+'/live'" width="100%" height="100%" frameborder="0"></iframe>
      -->
    </Content>
  </Layout>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex'

import PreviewPlayer from "./PreviewPlayer"
const moment = require('moment');
var momentDurationFormatSetup = require("moment-duration-format");
momentDurationFormatSetup(moment);

export default {
  data() {
    return {
      loading: true,
      selectedStream: null
    }
  },
  components: {
    PreviewPlayer
  },
  computed: {
    ...mapGetters("current", {
      current: "get"
    }),
    webcast() {
      return this.current("webcast");
    },
    ...mapGetters('stream', {
       streamsInStore: 'find',
       stream: 'getCopy'
    }),
    ...mapGetters('webcast-session', {
       getSessionInStore: 'get',
    }),
    streams(){
      return this.streamsInStore({query:{}}).data;
    },
    duration(){
      let currentSession = this.getSessionInStore(this.webcast.currentSessionId);
      if(currentSession) {
        let duration = moment.duration(moment().diff(currentSession.createdAt)).format("hh:mm:ss")
        //return duration.hours()+":"+duration.minutes()+":"+duration.seconds()
        return duration
      }
      else return 0

    },
    streamStatus (){
      console.log(this.webcast.status);
      return this.webcast.status;
    }
  },
  watch:{
    streamStatus(s){
      console.log(s);
    },
    webcast(){
      if(this.webcast.status == "live" && this.webcast.currentSessionId){
        this.getSessionAction(this.webcast.currentSessionId).then((session)=>{});
      }
    }
  },
  methods:{
    ...mapActions('webcast', {
      updateWebcastAction: 'patch',
      getWebcast: 'get'
    }),
    ...mapActions('webcast-session', {
      updateSessionAction: 'patch',
      getSessionAction: 'get',
      createSessionAction: 'create',
      findSessionAction: 'find'
    }),
    ...mapActions('stream', {
      findStreamsAction: 'find',
    }),
    changeCurrentStream(item){
      console.log(this.selectedStream);
      this.$store.commit('stream/setCurrent', this.selectedStream)
    },
    startStream(){
      console.log("starting")
      const payload = {
        webcastId: this.webcast._id
      }

      this.updateWebcastAction([
        this.webcast._id,
        {
          status: "live",
        },
        {}
      ]).then((resp)=>{
        this.$Message.success("Webcast has been started");
      })
    },
    stopStream(){
      console.log("stopping")
      this.updateWebcastAction([
        this.webcast._id,
        {
          status: "upcoming",
        },
        {}
      ]).then((resp)=>{
        this.$Message.success("Webcast has been stopped");
      })
    },
    endStream(){
      console.log("ending")
      this.updateWebcastAction([
        this.webcast._id,
        {
          status: "ended",
        },
        {}
      ]).then((webcast)=>{
        this.$Message.success("Webcast has been ended");
      })
    }
  },
  created(){
    this.findStreamsAction({
      query:{
        webcastId: this.webcast._id,
      }
    }).then((streams)=>{
      this.selectedStream = streams.data[0]._id;
      this.$store.commit('stream/setCurrent', streams.data[0])
    });

    if(this.webcast.currentSessionId){
      this.getSessionAction(this.webcast.currentSessionId).then((session)=>{});
    }
  }
}
</script>

<style lang="less">
.ivu-layout-sider {
  .ivu-btn {
    margin-bottom: 16px;
  }
}
</style>
